/**
 * <s-contact-prefill> — preselects contact form fields from the URL.
 *
 * Example: /pages/contact?type=corporate&forfait=signature&occasion=Mariage
 *
 * Required markup:
 *   select[data-prefill-param="<url param>"] option[data-key="<value>"]
 *   input[data-prefill-param="<url param>"] — receives the param's text when empty
 */
class SContactPrefill extends HTMLElement {
  connectedCallback() {
    const params = new URLSearchParams(window.location.search);

    for (const field of this.querySelectorAll('[data-prefill-param]')) {
      const wanted = params.get(field.dataset.prefillParam);
      if (!wanted) continue;

      if (field instanceof HTMLSelectElement) {
        const option = field.querySelector(`option[data-key="${CSS.escape(wanted.toLowerCase())}"]`);
        if (option) field.value = option.value;
      } else if (field instanceof HTMLInputElement && field.value === '') {
        field.value = wanted.slice(0, 100);
      }
    }
  }
}

if (!customElements.get('s-contact-prefill')) {
  customElements.define('s-contact-prefill', SContactPrefill);
}
